import React, { Component } from "react";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";
import EntityTeeTimeRequestEngagement from "../../../assets/components/reports/EntityTeeTimeRequestEngagement";

class EntityTeeTimeRequestEngagementReport extends Component {
    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>Entity Tee-Time Request Engagement</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col'>
                        <EntityTeeTimeRequestEngagement />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default EntityTeeTimeRequestEngagementReport;
